/** Guest cart line stored in browser storage. */
export interface CartItem {
  catalogId: number;
  catalogSlug: string;
  variantId: number | null;
  variantName: string | null;
  productName: string;
  imageUrl: string;
  unitPrice: number;
  quantity: number;
}

export interface AddToCartInput {
  catalogId: number;
  catalogSlug: string;
  variantId: number | null;
  variantName: string | null;
  productName: string;
  imageUrl: string;
  unitPrice: number;
  quantity: number;
}

export interface StoredCartData {
  sessionId: string;
  expiresAt: number;
  items: CartItem[];
  pendingCouponCode?: string;
}

export const CART_SESSION_COOKIE = 'hon_cart_session';
export const CART_STORAGE_KEY = 'hon_cart_data';
export const CART_EXPIRY_DAYS = 7;
export const FREE_SHIPPING_THRESHOLD = 65;
